const addEditFragment = `
     viewer {
        guid
        isAdmin
    }
    site {
        guid
        customTagsAllowed
        tagCategories {
            name
            values
        }
        profileFields {
            guid
            name
            fieldType
            isOnVcard
        }
        chatEnabled
        autoMembershipProfileFields {
            guid
            name
            fieldOptions
        }
        collaboraPerGroup
    }
`
export default addEditFragment
